import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Logo from "./Logo";
import { setLang } from "../i18n";

const LANGS = ["fr", "de", "en"];

export default function Footer() {
  const { t, i18n } = useTranslation();
  return (
    <footer className="border-t border-line bg-sand">
      <div className="mx-auto grid max-w-[1400px] gap-12 px-5 py-16 md:grid-cols-4 md:px-10">
        <div className="md:col-span-2">
          <Logo />
          <p className="mt-6 max-w-sm font-serif text-2xl font-light leading-snug text-ink">
            {t("footer.tagline")}
          </p>
        </div>
        <div>
          <p className="mb-4 text-xs uppercase tracking-widest text-ink3">{t("footer.explore")}</p>
          <ul className="space-y-2 text-sm text-ink2">
            <li><Link to="/catalogue" className="link-underline">{t("nav.catalog")}</Link></li>
            <li><Link to="/produits" className="link-underline">{t("nav.products")}</Link></li>
            <li><Link to="/atelier" className="link-underline">{t("nav.atelier")}</Link></li>
            <li><Link to="/panier" className="link-underline">{t("nav.cart")}</Link></li>
            <li><Link to="/admin" className="link-underline">{t("footer.pro")}</Link></li>
          </ul>
        </div>
        <div>
          <p className="mb-4 text-xs uppercase tracking-widest text-ink3">{t("footer.contact")}</p>
          <ul className="space-y-2 text-sm text-ink2">
            <li>o.creasubli@gmail.com</li>
            <li>Suisse · CHF</li>
          </ul>
          <p className="mb-3 mt-6 text-xs uppercase tracking-widest text-ink3">{t("footer.legal")}</p>
          <ul className="space-y-2 text-sm text-ink2">
            <li><Link to="/legal/mentions-legales" className="link-underline">{t("footer.legal_notice")}</Link></li>
            <li><Link to="/legal/cgv" className="link-underline">{t("footer.terms")}</Link></li>
            <li><Link to="/legal/confidentialite" className="link-underline">{t("footer.privacy")}</Link></li>
            <li><Link to="/legal/cookies" className="link-underline">{t("footer.cookies")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="flex flex-wrap items-center justify-between gap-4 border-t border-line px-5 py-6 md:px-10">
        <p className="text-xs tracking-wide text-ink3">© {new Date().getFullYear()} o-crea — {t("footer.rights")}</p>
        <div className="flex items-center gap-2" data-testid="lang-switcher">
          <span className="mr-1 text-[10px] uppercase tracking-widest text-ink3">{t("footer.language")}</span>
          {LANGS.map((l) => (
            <button
              key={l}
              onClick={() => setLang(l)}
              data-testid={`lang-${l}`}
              className={`border px-2.5 py-1 text-[11px] uppercase tracking-widest transition-colors ${
                i18n.language === l ? "border-ink bg-ink text-cream" : "border-line text-ink2 hover:bg-cream"
              }`}
            >
              {l}
            </button>
          ))}
        </div>
      </div>
    </footer>
  );
}
